import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Animated } from 'react-native';

const FadeView = ({ style, children, duration, fadeOut }) => {
    const [fadeAnim] = useState(new Animated.Value(0));

    useEffect(() => {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration,
            useNativeDriver: true
        }).start();

        if (fadeOut) {
            return () => {
                Animated.timing(fadeAnim, {
                    value: 1,
                    toValue: 0,
                    duration,
                    useNativeDriver: true
                }).start();
            };
        }

        return () => {};
    }, []);

    return (
        <Animated.View
            style={{
                ...style,
                opacity: fadeAnim
            }}
        >
            {children}
        </Animated.View>
    );
};

FadeView.defaultProps = {
    style: {
        flex: 1
    },
    children: [],
    duration: 300,
    fadeOut: true
};

FadeView.propTypes = {
    style: PropTypes.shape({}),
    children: PropTypes.any,
    duration: PropTypes.number,
    fadeOut: PropTypes.bool
};

export default FadeView;
